module.exports = __webpack_public_path__ + "static/media/mr.0c172d6d.svg";